import isEmpty from 'lodash.isempty';

/**
 * Manages the refinement filters "pills" across
 * all refinement attributes.
 */
class RefinementFiltersManager {
  constructor(container) {
    this.container = document.querySelector(container);
    this.filters = {};

    const filtersUl = document.createElement('ul');
    filtersUl.classList.add('search-filters__list');

    this.container.appendChild(filtersUl);
  }

  /**
   * Set filter items for an attribute.
   *
   * @param string attribute filter attribute
   * @param array  items     current items for attribute
   * @param func   refine    refine function for attribute
   */
  setFilters(attribute, items, refine) {
    if (isEmpty(items)) {
      delete this.filters[attribute];
    } else {
      this.filters[attribute] = { items, refine };
    }

    this.update();
  }

  /**
   * Are any filter items toggled on?
   *
   * @return bool
   */
  isVisible() {
    return !isEmpty(this.filters);
  }

  /**
   * Update refinement filters container with
   * current items.
   */
  update() {
    const filterEntries = Object.entries(this.filters);

    const filtersHTML = filterEntries.reduce((acc, [attribute, { items }]) => {
      const itemsHTML = items
        .map(
          item => `
        <li class="search-filters__list-item">
          <button class="search-filters__list-item__button" data-value="${item.value}" data-attribute="${attribute}">
            <svg class="search-filters__list-item__button-icon">
              <use href="#x" xlink:href="#x"></use>
            </svg>

            <span class="search-filters__list-item__button-text">${item.label}</span>
          </button>
        </li>
      `,
        )
        .join('');

      return acc + itemsHTML;
    }, '');

    this.container.querySelector('ul').innerHTML = filtersHTML;

    [...this.container.querySelectorAll('button')].forEach(element => {
      element.addEventListener('click', e => {
        e.preventDefault();
        const { refine } = this.filters[e.currentTarget.dataset.attribute];
        refine(e.currentTarget.dataset.value);
      });
    });
  }
}

export default RefinementFiltersManager;
